import components from "./components.config";
import palette from "./palette.config";
import systemStatus from "./system-status.config";
import typography from "./typography.config";

export const themeOption = {
  typography,
  palette,
  components,
  systemStatus,
};
